class TabsWidget extends HTMLElement {
  constructor() {
    super();
    this.tabButtons = this.querySelectorAll('.tabs__nav-item');
    this.tabPanels = this.querySelectorAll('.tabs__panel');
  }

  connectedCallback() {
    this.tabButtons.forEach(button => {
      button.addEventListener('click', () => this.loadTab( button, button.getAttribute('data-tab') ));
    });
  }

  loadTab( button, target ) {
    this.tabButtons.forEach(tab => tab.classList.remove('tabs__nav-item--active'));
    this.tabPanels.forEach(panel => panel.classList.remove('tabs__panel--active'));

    button.classList.add('tabs__nav-item--active');
    this.querySelector(`#${target}`).classList.add('tabs__panel--active');
  }
}

/**
 * Initialize tabs widget
 * Following the same pattern as other modules
 */
export function initTabsWidget() {
  if (!customElements.get('tabs-widget')) {
    customElements.define('tabs-widget', TabsWidget);
    console.info('Tabs Widget module initialized');
  }
}

export default TabsWidget;
